// extracted by mini-css-extract-plugin
export default {"closeButton":"ClosePageButtonComponent_closeButton__ouzda"};